// extracted by mini-css-extract-plugin
module.exports = {"container":"Preloader_container__3gbrS","heading":"Preloader_heading__372rm","loading":"Preloader_loading__1bUCY"};